import React, { useState } from "react";
import PropTypes from "prop-types";

import feedstyles from "src/Assets/css/home/feedpost.module.css";
import sampledialogcancel from "src/Assets/images/Add.png";
import dot from "src/Assets/images/dot.png";
import { Divider } from "@material-ui/core";
import API from "../../../network";
import AvatarBadge from "src/Components/AvatarBadge";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import alreadyImpactfulMemberImg from "src/Assets/images/already_impactful_img.png";
import inviteToBeImapctFullMemberImage from "src/Assets/images/impactful_nominate_img_new.png";
import NominateUser from "src/Modules/Moderator/ReusableModeratorComponents/NominateUser";
import { useSelector } from "react-redux";

function SimpleDialog(props) {
  const { onClose, open, isActionDisabled = false } = props;

  const handleClose = () => {
    onClose(false);
  };
  const userDetails = useSelector((state) => state.SignInReducer.userDetails);

  const communityFollowNames = userDetails?.userData?.communityFollowNames || [];
  const currentTenantId =
    userDetails?.userData?.viewActivityUserTenantInfo?.tenantId;
  const hasFollowedCommunity = communityFollowNames.some(
    (c) =>
      String(c.id) === String(currentTenantId) ||
      String(c.tenantID) === String(currentTenantId) ||
      String(c.tenantId) === String(currentTenantId)
  );
  const isPrivate =
    isActionDisabled ||
    String(
      userDetails?.userData?.viewActivityUserTenantInfo?.communityType
    ).toLowerCase() === "private";
  const isNominateDisabled = isActionDisabled || (isPrivate && !hasFollowedCommunity);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "0px",
    boxShadow: 24,
    padding: "10px 25px",
    borderRadius: "20px",
  };

  var profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;

  return (
    <Modal
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      key={`simpleDialog${props.id}`}
      maxWidth="md"
      sx={{
        zIndex: 2000,
      }}
    >
      <Box sx={style}>
        {props.Followers ? (
          <div className={feedstyles.sampledialogcountandcancel}>
            <p className={feedstyles.sampledialogtotalcount}>
              <b>{props.Followers} following</b>
            </p>
            <div onClick={handleClose}>
              <img
                src={sampledialogcancel}
                style={{
                  backgroundColor: "#F3F2F0",
                  borderRadius: "50%",
                  padding: "12%",
                }}
                alt=""
              />
            </div>
          </div>
        ) : (
          <div className={feedstyles.sampledialogcountandcancel}>
            <p className={feedstyles.sampledialogtotalcount}>
              {props.likes === 1 ? (
                <b>{props.likes} Like</b>
              ) : (
                <b>{props.likes} likes</b>
              )}
            </p>
            <div onClick={handleClose}>
              <img src={sampledialogcancel} alt="" />
            </div>
          </div>
        )}
        {props.followersData ? (
          props.followersData.map((followersresult, index) => (
            <>
              <div
                key={`followersData${index}${followersresult?.saycount}`}
                className={feedstyles.followersmodal}
              >
                <AvatarBadge
                  src={`${profileImagePath}${followersresult.uimage}`}
                  className={feedstyles.sampledialogvatar}
                  size={50}
                  isPrimaryModerator={followersresult.isPM == 1}
                  isModerator={
                    followersresult.isModerator == 1 &&
                    followersresult.isPM == 0
                  }
                />
                <div style={{ marginLeft: "10px" }}>
                  <span className={feedstyles.profilename}>
                    {followersresult?.displayName}
                    {followersresult?.isImpactableMember === "yes" && (
                      <img
                        src={alreadyImpactfulMemberImg}
                        alt="Impactful Member"
                        title="Impactful Member"
                        style={{
                          width: "18px",
                          height: "18px",
                          objectFit: "contain",
                          flexShrink: 0,
                          marginLeft: "5px",
                        }}
                      />
                    )}
                  </span>
                  <p className={feedstyles.sampledialgoxtext}>
                    ASK {followersresult.askcount} | SAY{" "}
                    {followersresult.saycount} | UPDATE{" "}
                    {followersresult.updatecount} | TAG{" "}
                    {followersresult.hashtagcount} | Answers{" "}
                    {followersresult.answercount} | Replies{" "}
                    {followersresult.replycount}
                  </p>
                </div>
                {followersresult?.userid !== userDetails?.userData?.User_ID && (
                  <NominateUser result={followersresult} disabled={isNominateDisabled}>
                    <button
                      type="button"
                      style={{
                        padding: 0,
                        margin: 0,
                        border: "none",
                        background: "transparent",
                        cursor: isNominateDisabled ? "not-allowed" : "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        outline: "none",
                      }}
                    >
                      <img
                        src={inviteToBeImapctFullMemberImage}
                        alt="Invite"
                        title={isNominateDisabled ? "Follow community to nominate" : "Nominate as Impactful Member"}
                        style={{
                          width: "23px",
                          height: "23px",
                          objectFit: "contain",
                          display: "block",
                        }}
                      />
                    </button>
                  </NominateUser>
                )}
              </div>
              <Divider className={feedstyles.divider} />
            </>
          ))
        ) : props.likesData ? (
          props.likesData.map((likesresult, index) => (
            <>
              <div
                key={`likesData${index}${likesresult?.saycount}`}
                className={feedstyles.followersmodal}
              >
                <AvatarBadge
                  src={`${profileImagePath}${likesresult.uimage}`}
                  className={feedstyles.sampledialogvatar}
                  size={50}
                  isPrimaryModerator={likesresult.isPM == 1}
                  isModerator={
                    likesresult.isModerator == 1 && likesresult.isPM == 0
                  }
                />
                <div style={{ marginLeft: "10px" }}>
                  <p className={feedstyles.sampledialogdisplayname}>
                    {likesresult.displayName}
                  </p>
                  <p className={feedstyles.sampledialgoxtext}>
                    ASK {likesresult.askcount} | SAY {likesresult.saycount} |
                    UPDATE {likesresult.updatecount} | TAG{" "}
                    {likesresult.hashtagcount} | Answers{" "}
                    {likesresult.answercount} | Replies{" "}
                    {likesresult.replycount}
                  </p>
                </div>
              </div>
              <Divider className={feedstyles.divider} />
            </>
          ))
        ) : (
          <span>NO Data</span>
        )}
      </Box>
    </Modal>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function SimpleDialogDemo(props) {
  const [followerCountData, setFollowerCountData] = useState(0);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = async (id, type) => {
    setOpen(true);
    const response = await API.fetchFollowerCount(id, type);
    if (response) {
      setFollowerCountData(response.data);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div key={`followerorlikes${props.id}`}>
      {props.followCount || props.followCount === 0 ? (
        <p
          onClick={() => {
            if (props.followCount > 0) {
              handleClickOpen(props.id, "follow");
            }
          }}
          // id={props.id}
          className={feedstyles.askTagPopupFollowers}
        >
          {props.followCount === 1
            ? `${props.followCount} follower`
            : `${props.followCount} followers`}
        </p>
      ) : (
        <p
          variant="outlined"
          // color="primary"
          onClick={() => {
            if (props.voteUp > 0) handleClickOpen(props.id, "like");
          }}
          // id={props.id}
          className={feedstyles.followerbgcolor}
        >
          {props.voteUp === 1
            ? `${props.voteUp} like`
            : `${props.voteUp} likes`}
        </p>
      )}

      {props.hashTagType === "private" && (
        <span className={feedstyles.hashTagType}>
          <span>
            <img src={dot} alt="dot" />
          </span>{" "}
          Private
        </span>
      )}

      {!!followerCountData && Object.keys(followerCountData).length !== 0 && (
        <SimpleDialog
          open={open}
          onClose={handleClose}
          Followers={props.followCount}
          followersData={followerCountData.follweduserprofile}
          key={props.id}
          likes={props.voteUp}
          likesData={followerCountData.likeduserprofile}
        />
      )}
    </div>
  );
}
